var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-Popover"},[_c('div',{staticClass:"md-Popover_Box",attrs:{"data-arrow":_vm.dataArrow}},[(_vm.canClose)?_c('div',{staticClass:"md-Popover_Close",on:{"click":_vm.close}},[_vm._v("×")]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }